import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { Media } from '@klickdata/core/media/src/media.model';
import { MediaService } from '@klickdata/core/media/src/media.service';
import { MessageSavedComponent } from '@klickdata/core/message';
import { MessageService } from '@klickdata/core/message/src/message.service';
import { User } from '@klickdata/core/user';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { OnDestroyHandler } from '../../onDestroy-handler/onDestroy-handler';
@Component({
    selector: 'app-dialog-display-img',
    templateUrl: './dialog-display-img.component.html',
    styleUrls: ['./dialog-display-img.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDisplayImgComponent extends OnDestroyHandler implements OnInit {
    public favorite = false;
    public imgAccess: FormControl = new FormControl();
    public authUser$: Observable<User>;
    public isMediaLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public loadedMedia: Media;
    constructor(
        public dialogRef: MatDialogRef<DialogDisplayImgComponent>,
        @Inject(MAT_DIALOG_DATA) public media: Media,
        private mediaService: MediaService,
        private messageService: MessageService,
        private cd: ChangeDetectorRef,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit(): void {
        this.authUser$ = this.authService.getUser();
        if (this.media.id) {
            this.mediaService
                .getMedia(+this.media.id, 'large', 'author,tags,user_feeds')
                .pipe(takeUntil(this.destroy))
                .subscribe((media) => {
                    this.loadedMedia = media;
                    this.isMediaLoaded$.next(true);
                    this.imgAccess.patchValue(this.media.visibility, { emitEvent: false });
                    this.favorite = this.media.user_feeds?.favorite;
                    this.cd.markForCheck();
                });
        }

        this.imgAccess.valueChanges
            .pipe(
                takeUntil(this.destroy),
                filter(() => !!this.loadedMedia.id),
                switchMap((value) => this.mediaService.updateMedia(+this.loadedMedia.id, { visibility: value }))
            )
            .subscribe((media) => {
                this.messageService.openMessage(MessageSavedComponent);
            });
    }

    edit() {
        this.dialogRef.close({ type: 'edit', media: this.loadedMedia ?? this.media });
    }

    updateFavorite() {
        if (!this.loadedMedia.id) return;
        this.mediaService
            .updateMedia(+this.loadedMedia.id, { favorite: this.favorite })
            .pipe(takeUntil(this.destroy))
            .subscribe((media) => {
                this.messageService.openMessage(MessageSavedComponent, 'Favorite updated');
                this.cd.markForCheck();
            });
    }
    get tooltipInfo() {
        if (!this.loadedMedia) return '';
        return [
            this.media.author?.name ? $localize`Created by: ` + this.media.author.name : '',
            this.media.created_at ? $localize`Created at: ` + moment(this.media.created_at).format('YYYY-MM-DD') : '',
            this.media.name ?? this.media.filename
                ? $localize`File name: ` + (this.media.name ?? this.media.filename)
                : '',
            this.media.type ? $localize`Type: ` + this.media.type : '',
            this.media.description ? $localize`Description: ` + this.media.description : '',
        ].join('\n');
    }
}
